import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DismissibleNotificationsOptInBanner from "../../../presentational/common/DismissibleNotificationsOptInBanner";
import {
  initNotificationsOptInBanner,
  dismissNotificationsOptInBanner,
  hideNotificationsOptInBanner,
  optInToNotifications
} from "../../../../state/modules/savedItems/actions";
import {
  getShouldShowNotificationsOptIn,
  getNotificationsOptInSuccess,
  getNotificationsOptInBucket
} from "../../../../state/modules/savedItems/selectors";
import getUserIsAuthenticated from "../../../../state/modules/identity/selectors/getUserIsAuthenticated";

const NotificationsOptInBannerContainer = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getUserIsAuthenticated);
  const shouldShowNotificationsOptIn = useSelector(
    getShouldShowNotificationsOptIn
  );
  const isSuccess = useSelector(getNotificationsOptInSuccess);
  const bucket = useSelector(getNotificationsOptInBucket);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(initNotificationsOptInBanner());
    }
  }, [isAuthenticated]);

  return (
    <DismissibleNotificationsOptInBanner
      showNotificationsOptInBanner={
        shouldShowNotificationsOptIn && bucket === "banner"
      }
      onDismiss={() =>
        isSuccess
          ? dispatch(hideNotificationsOptInBanner())
          : dispatch(dismissNotificationsOptInBanner())
      }
      onNotifyMe={() => dispatch(optInToNotifications())}
      isSuccess={isSuccess}
    />
  );
};

export default NotificationsOptInBannerContainer;
